import { render, staticRenderFns } from "./portal-customer-login.vue?vue&type=template&id=275638cf&scoped=true"
import script from "./portal-customer-login.vue?vue&type=script&lang=js"
export * from "./portal-customer-login.vue?vue&type=script&lang=js"
import style0 from "./portal-customer-login.vue?vue&type=style&index=0&id=275638cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275638cf",
  null
  
)

export default component.exports